import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { TextField, FormGroup, FormControlLabel, Switch, Stack, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';
import SharedDialog from '../../common/dialog/SharedDialog';
import MultiLangDialogAndSingleDisplayIpt from './MultiLangDialogAndSingleDisplayIpt';
import { EXCLUDE_FOR_SIDEBAR_IPTS, KEYS_OF_FILTER_KEY_LIST, NODE_TYPES } from '../constant';
import useFilterKey from '../hooks/useFilterKey';


export default function SbcCommon({
    data,
    handleIptChange,
    handleMultiIptChange,
    handleSwitchChange,
    handleSelectChange
}) {

    const { filterKeyList, setStorageItem } = useFilterKey(KEYS_OF_FILTER_KEY_LIST)

    const keysToExclude = EXCLUDE_FOR_SIDEBAR_IPTS?.[data?.type] || []

    return (
        <Stack direction={'column'} spacing={1}>
            <FormControl fullWidth>
                <InputLabel id="type-label">Type</InputLabel>
                <Select
                    variant='filled'
                    labelId="type-label"
                    id="type"
                    label="Type"
                    value={data?.type || ''}
                    color='success'
                    name='type'
                    onChange={handleSelectChange}
                >
                    {Object.keys(NODE_TYPES).map(key => <MenuItem key={key} value={NODE_TYPES[key]}>{NODE_TYPES[key]}</MenuItem>)}
                </Select>
            </FormControl>
            <MultiLangDialogAndSingleDisplayIpt
                keyName={'question'}
                valueObj={data?.question}
                handleMultiIptChange={handleMultiIptChange}
            />
            <MultiLangDialogAndSingleDisplayIpt
                keyName={'answerLabel'}
                valueObj={data?.answerLabel}
                handleMultiIptChange={handleMultiIptChange}
            />
            <FormGroup>
                <FormControlLabel
                    label="Required"
                    control={<Switch name='mandatory' checked={data?.mandatory} onChange={handleSwitchChange} />}
                    color='success'
                />
            </FormGroup>
            <TextField
                variant='filled'
                type='text'
                color='success'
                label='Sequence'
                name='sequence'
                value={data?.sequence || ''}
                onChange={handleIptChange}
            />
            {
                !keysToExclude.includes('inputMode') && (
                    <FormControl fullWidth>
                        <InputLabel id="select-label">Input Mode</InputLabel>
                        <Select
                            variant='filled'
                            labelId="select-label"
                            id="select"
                            label="Input Mode"
                            value={data?.inputMode || ''}
                            color='success'
                            name='inputMode'
                            onChange={handleSelectChange}
                        >
                            <MenuItem value={'normal'}>Normal</MenuItem>
                            <MenuItem value={'number'}>Number</MenuItem>
                        </Select>
                    </FormControl>
                )
            }
            {
                !keysToExclude.includes('inputRegex') && (
                    <TextField
                        variant='filled'
                        type='text'
                        color='success'
                        label='Input RegEx'
                        name='inputRegex'
                        value={data?.inputRegex || ''}
                        onChange={handleIptChange}
                    />
                )
            }
            {
                !keysToExclude.includes('minSize') && (
                    <TextField
                        variant='filled'
                        type='number'
                        color='success'
                        label='Min Character Length'
                        name='minSize'
                        value={data?.minSize || ''}
                        onChange={handleIptChange}
                    />
                )
            }
            {
                !keysToExclude.includes('maxSize') && (
                    <TextField
                        variant='filled'
                        type='number'
                        color='success'
                        label='Max Character Length'
                        name='maxSize'
                        value={data?.maxSize || ''}
                        onChange={handleIptChange}
                    />
                )
            }
            <TextField
                variant='filled'
                type='text'
                color='success'
                label='Filter Key'
                name='filterKey'
                value={data?.filterKey || ''}
                inputProps={{
                    list: "itemList"
                }}
                onChange={handleIptChange}
                onBlur={e => setStorageItem(e.target.value)}
            />
            <datalist id="itemList">
                {filterKeyList?.map(i => <option key={i?.value}>{i?.value}</option>)}
            </datalist>
        </Stack>
    )
}
